import React from "react"

export const Loading = () => {
    return <div className="container-loading"></div>
}


// WEBPACK FOOTER //
// ./src/common/components/loading.jsx